import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.mosaic.Action.Input,
    graphql.schema.MosaicActionInput
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    // NOTE: onNullish: 'preserve' is set because if we have null in query, we
    // don't want to remove/replace it because then we won't get correct data by
    // that query
    query: graphql.transformers.IN.stringify({ onNullish: 'preserve' }),
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.mosaic.Action.Updates,
    graphql.schema.MosaicActionUpdates
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    // NOTE: onNullish: 'preserve' is set because if we have null in query, we
    // don't want to remove/replace it because then we won't get correct data by
    // that query
    query: graphql.transformers.IN.stringify({ onNullish: 'preserve' }),
  }),
)
